import React from "react";
import Modal from "react-modal";

// Set app element for accessibility (do this in your app's entry point)
Modal.setAppElement("#root");

const CopyResultDialog = ({ open, onClose, result }) => (
  <Modal
    isOpen={open}
    onRequestClose={onClose}
    contentLabel="Copy Results"
    className="bg-white rounded-lg shadow-lg max-w-lg w-full mx-auto p-6 mt-24 outline-none"
    overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
    shouldCloseOnOverlayClick={true}
  >
    <h2 className="text-lg font-bold mb-2">Copy Results</h2>
    <div className="mb-4">
      <p className="text-green-600 font-semibold">
        Copied: {result?.copied ?? 0}
      </p>
      <p className="text-red-600 font-semibold">
        Conflicts: {result?.conflicts ?? 0}
      </p>
      <p className="mt-2 text-gray-700">{result?.message || ""}</p>
    </div>
    {result?.conflictDetails?.length > 0 && (
      <div className="mb-4">
        <div className="font-semibold mb-1">Conflicted Schedules:</div>
        <ul className="max-h-32 overflow-y-auto text-sm list-disc pl-5">
          {result.conflictDetails.map((conflict, idx) => (
            <li key={idx} className="mb-1">
              <span className="font-mono">
                User: {conflict.userID?.preferredName}
                <br />
                Location: {conflict.locationID?.name}
                <br />
                Date: {conflict.startTime.slice(0, 10)}
                <br />
                {new Intl.DateTimeFormat(undefined, {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
                }).format(new Date(conflict.startTime))}{" "}
                ~{" "}
                {new Intl.DateTimeFormat(undefined, {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
                }).format(new Date(conflict.endTime))}
              </span>
            </li>
          ))}
        </ul>
      </div>
    )}
    <div className="flex justify-end">
      <button
        onClick={onClose}
        className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 transition"
      >
        OK
      </button>
    </div>
  </Modal>
);

export default CopyResultDialog;
